const paymentRoutes = {
  pix: () => "confirmacao-pix",
  credit: () => "pagamento-sucesso",
};

export default paymentRoutes;
